export default {
  processes: 0,
};
